/*
 * image-gallery 图片画廊（折叠展开）
 * Schema: string[] | { url, thumbnail? }[]
 */
import React, { useState } from 'react'
import { tryParseJson, ImageGalleryItem } from './types'
import { useInvalidBlockWarning } from './useInvalidBlockWarning'
import { ImagePreview } from '../ImagePreview'
import './ImageGalleryBlock.scss'

interface ImageGalleryBlockProps {
  code: string
}

const COLLAPSE_THRESHOLD = 6

function normalize(
  items: ImageGalleryItem[]
): { url: string; thumbnail?: string }[] {
  return items.map((item) => (typeof item === 'string' ? { url: item } : item))
}

export const ImageGalleryBlock: React.FC<ImageGalleryBlockProps> = ({
  code
}) => {
  const data = tryParseJson<ImageGalleryItem[]>(code)
  const [expanded, setExpanded] = useState(false)
  const [previewSrc, setPreviewSrc] = useState<string | null>(null)

  // 流式中 JSON 未收齐时 silent 不渲染，避免闪"图片数据无效"（对齐 FileListBlock）；
  // 流式结束后仍无效 → useInvalidBlockWarning 会 console.warn 留排查线索
  const valid = Array.isArray(data) && data.length > 0
  useInvalidBlockWarning('image-gallery', code, valid)
  if (!Array.isArray(data) || data.length === 0) {
    return null
  }

  const items = normalize(data)
  const showAll = expanded || items.length <= COLLAPSE_THRESHOLD
  const visible = showAll ? items : items.slice(0, COLLAPSE_THRESHOLD)
  const hiddenCount = items.length - COLLAPSE_THRESHOLD

  return (
    <div className="aiClerk-block-gallery">
      <div className="aiClerk-block-gallery__grid">
        {visible.map((img, i) => (
          <div
            key={i}
            className="aiClerk-block-gallery__cell"
            onClick={() => setPreviewSrc(img.url)}
          >
            <img
              src={img.thumbnail || img.url}
              alt={`img-${i + 1}`}
              loading="lazy"
            />
          </div>
        ))}
      </div>
      {!showAll && (
        <button
          className="aiClerk-block-gallery__expand"
          onClick={() => setExpanded(true)}
        >
          展开剩余 {hiddenCount} 张 ↓
        </button>
      )}
      {showAll && items.length > COLLAPSE_THRESHOLD && (
        <button
          className="aiClerk-block-gallery__expand"
          onClick={() => setExpanded(false)}
        >
          收起 ↑
        </button>
      )}

      <ImagePreview
        src={previewSrc}
        alt="图片预览"
        onClose={() => setPreviewSrc(null)}
      />
    </div>
  )
}
